import { Outlet } from 'react-router-dom';
import { Header, SideBar } from 'components/base';

const Layout: React.FC = () => {
  return (
    <div className={`font-poppins tracking-wide text-textGray relative`}>
      <div className='top-0 left-0 w-full z-50 fixed'>
        <Header />
      </div>
      <div className={`flex mt-12 bg-white`}>
        <SideBar />
        <div className='pt-[1.5rem] pl-[1rem] pr-4 md:pr-[2rem] text-black w-full'>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
